import type {ProfileModelType} from "#shared-package/profile-model.ts";

import type {ProfileDropdownData} from "./user-dropdown.tsx";

// sync-start:triggerless-modal-focus-anchor 1923213161 apps/khanacademy/src/components/modal-package/deprecated-modal.tsx
export const TRIGGLESS_MODAL_FOCUS_ANCHOR_ID = "triggerless-modal-focus-anchor";
// sync-end:triggerless-modal-focus-anchor

// sync-start:khanmigo-tools-paths 414783184 apps/khanacademy/src/coach-dashboard-package/khanmigo/path-helpers.ts
export const PARENT_KHANMIGO_TOOLS_PATH: string = "/parent/khanmigo-tools";
// sync-end:khanmigo-tools-paths

// Remove the HTML tags from a string (while leaving the text inside the tags).
export const removeHTMLTags = (string = ""): string => {
    return string
        .replace(/<[^>]*>/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
};

// Returns a profile data object required for the Profile/User menu.
// TODO(LP-8552): Update UserSettings to use WithUserProfile instead.
export const getProfileDropdownData = (
    profile: ProfileModelType | null,
): ProfileDropdownData | null => {
    if (!profile) {
        return null;
    }

    const isPhantom = profile.get("isPhantom");
    const hasStudents = profile.get("hasStudents");
    const hasClasses = profile.get("hasClasses");
    const hasChildStudents = profile.get("hasChildStudents");
    const hasChildren = hasStudents && hasChildStudents;

    const baseData = {
        profileUrl: profile.get("profileRoot"),
        nickName: profile.get("nickname"),
        isPhantom,
        showSignUpToSave: isPhantom && !profile.get("isMidsignupPhantom"),
        hasStudents,
        hasChildren,
        showSettings: !isPhantom,
        isInKhanClassroomDistrict: !!profile.get("isInKhanClassroomDistrict"),
        showKhanAcademyClassroom: !!profile.get("isInKhanClassroomDistrict"),
    } as const;

    return {
        ...baseData,
        showTeacherLinks: profile.get("isTeacher") || hasClasses,
        showParentLinks: profile.get("isParent") || hasChildren,
        showAdministratorLinks: profile.get("canAccessDistrictsHomepage"),
    };
};
